import api from '../utils/api';

export const listingPhotoService = {
  /**
   * Gate C-F4 + perceptual hash verification for one capture.
   */
  verify: async (payload) => {
    const res = await api.post('/seller/listing-photos/verify', payload);
    return res.data?.data;
  },
};

export default listingPhotoService;
